<template>
  <div class="badge-container" data-testid="badge-container">
    <ExResponsibilityBadgeHolder
      :items="computedMenuItems"
      :badgeFrameItems="badgeFrameItems"
      :modalHeaderState="modalHeaderState"
      :currentResponse="currentResponse"
      :proficiencyValue="getWeight()"
      :breadItems="computedBreadItems"
      :dataStream="resChatter"
      :tasks="checklistTask"
      :totalChatterData="totalChatterData"
      @onButtonAction="openForceBadgeModal"
      @removeHolder="removeBadge($event)"
      @checkFormData="checkFormData($event)"
      @dropOption="checkDropdownOption"
      @optionClick="optionClick($event)"
      @requestMoreChatterData="getResponsiblityChatter(true)"
      @onUpdateTask="changeCheckpoint"
      @optionOrgObjClick="handleReadinessOperations($event)"
      @onUpdateCheckpointOrder="updateCheckpointOrder($event)"
      @tabChange="tabChange($event)"
      @get-chatter-list="getCheckpointChatterList($event, 1)"
      :chatterList="chatterList"
      :totalCheckpointChatter="totalCheckpointChatter"
      @requestMoreCheckpointsChatter="
        getCheckpointChatterList($event, chatterPage + 1)
      "
      :assignmentsList="assignmentsList"
      :totalAssignments="totalRespAssignments"
      @uploadVideo="uploadVideo($event)"
      @requestMoreResChatter="getResponsiblityChatter(true)"
      @removeBadge="removeBadge($event)"
      @weightChanged="weightChanged($event)"
      @onAIAction="getAICheckpoints"
      @addCheckpointWithAI="getAICheckpoints(true)"
      @createDefaultBadge="createDefaultBadge($event)"
      @filtersChanged="handleFiltersChanged"
      :showResponsibilityAssignmentTab="showResponsibilityAssignmentTab"
      :showResponsibilityDefaultTab="showResponsibilityDefaultTab"
      :responsibility="currentResponsibilityData"
      @openChatter="getResponsiblityChatter()"
    />
    <EmployeeModal
      :showStep="1"
      :dialog="showBadgeDialog"
      @onAction="addForceBadgeData($event)"
      @openEvalAction="openEvalResponse($event)"
      @back="backForceBadge"
      label="Employee"
      :name="currentResponse?.data?.name"
      :items="badgeEmployeeData"
      :activeCheckpoint="activeCheckPoints"
      :value="[1]"
      :enableEmployeePagination="true"
      :empForceBadgeClass="true"
      :key="employeeModalRenderKey"
      :responsibility="currentOrgResponsibility?.data"
      :employee="currentResponse?.data"
      @removeBadge="removeBadge"
      :isAssigningBadge="isAssigningBadge"
    />
    <GeneratingWithAIDialog
      :show="aiState.loading.show"
      @update:show="aiState.loading.show = $event"
      :text="aiState.loading.text"
    />
    <AICheckpointsDialog
      :show="aiState.dialog"
      @update:show="!$event ? resetAIData() : (aiState.dialog = $event)"
      :ai-data="aiState.data.visible"
      :responsibilityName="currentOrgResponsibility?.data?.name || ''"
      :actionButton="{
        show: aiState.data.remaining > 0,
        label: 'Show More...',
      }"
      @actionButtonClick="showThreeMoreAIData"
      @saveAIData="onSaveAIData"
      :key="aiCheckpointsDialogKey"
    />
    <RemoveBadgeDialog
      v-model="showRemoveBadgeDialog"
      :badgeName="
        selectedBadgeForRemoval?.badgeName ||
        selectedBadgeForRemoval?.level ||
        ''
      "
      :responsibilityName="
        currentOrgResponsibility?.data?.name ||
        currentResponse?.data?.name ||
        ''
      "
      :employeeName="selectedBadgeForRemoval?.employeeName || ''"
      @remove="handleConfirmRemoveBadge"
      @close="handleCloseRemoveBadgeDialog"
    />
    <ExDeleteCheckpoint
      v-model="showDeleteDialog"
      :name="checkpointData?.criteria"
      @onAction="deleteCheckpoint(checkpointId)"
    />
    <ActivateCheckpoint
      v-model="showActivateCheckpointDialog"
      :checkpoint="currentCheckPoint?.criteria || ''"
      @onSave="activateCheckpoint"
    />
    <RetireCheckpoint
      v-model="showRetireCheckpointDialog"
      :checkpoint="currentCheckPoint?.criteria || ''"
      @onSave="retireCheckpoint"
    />
    <ReActivateCheckpoint
      v-model="showReActivateCheckpointDialog"
      :checkpoint="currentCheckPoint?.criteria || ''"
      @onSave="reActivateCheckpoint"
    />
    <EvalResponsibilityModal
      v-if="openEvalResponsibility"
      :dialog="openEvalResponsibility"
      :badges="badges"
      :checkpointsData="checkpointsData"
      :evalModalHeaderState="evalModalHeaderState"
      :evalModalEmpState="evalModalEmpState"
      @closeModal="openEvalResponsibility = false"
      @updateEvaluationCheckPointData="updateEvaluationCheckPointData"
      @reloadData="updateEvaluationCheckPointData"
      @grantBadge="grantOrForceBadge"
      @removeBadge="removeBadgeByResponsibilityId"
      @reloadBadgeHolderItems="reloadBadgeHolderItems"
      @upgradeBadge="upgradeBadge"
      @showAwardBadge="showAwardBadge"
    />
    <RenameResponsibility
      v-model="showRenameResponsibilityDialog"
      @onSave="renameOrgResponsibility($event)"
      :responsibility="currentOrgResponsibility?.data?.name || ''"
    />
    <DeleteResponsibility
      v-model="deleteResponsibilityDialog"
      :responsibility="currentOrgResponsibility?.data?.name || ''"
      @onDelete="deleteOrgResponsibility"
    />
    <ActivateResponsibility
      v-model="showActivateResponsiblityDialog"
      :responsibility="currentOrgResponsibility?.data?.name || ''"
      @onSave="activateOrgResponsibility"
    />
    <RetireResponsibility
      v-model="showRetireResponsibilityDialog"
      :responsibility="currentOrgResponsibility?.data?.name || ''"
      @onSave="retireOrgResponsibility"
    />
    <DeActivateResponsibility
      v-model="showDeActivateResponsiblityDialog"
      :responsibility="currentOrgResponsibility?.data?.name || ''"
      @onSave="deActivateOrgResponsibility"
    />
    <ReActivateResponsibility
      v-model="showReActivateResponsiblityDialog"
      :responsibility="currentOrgResponsibility?.data?.name || ''"
      @onSave="reActivateOrgResponsibility"
    />
    <MoveCheckpointDialog
      v-model="showMoveCheckpointDialog"
      @onSave="moveCheckpoint()"
      OrgObjectType="Responsibility to Role"
      :items="items"
      @item-selected="handleItemSelected"
      @add-item-selected="addHandleItemSelected"
      :existingNamesList="existingResponsibilitiesNames"
      :parentName="currentOrgResponsibility?.data?.name || ''"
    />
    <ArchivePopUp
      :action="archiveAction"
      :type="currentObj"
      :show="showArchihvedResponsiblityDialog"
      :curretObj="currentOrgResponsibility"
      @onClose="showArchihvedResponsiblityDialog = false"
      @onArchive="onArchiveCatalogs"
    ></ArchivePopUp>
    <AttachedResponsibilityToRole
      v-model="showAttachRoleDialog"
      OrgObjectType="Responsibility to Role"
      @onSave="attachResponsibilityToRole"
      :type="
        showAttachResponsibilitiesPicker
          ? 'respToRole_new_picker'
          : 'respToRole'
      "
      :items="attachableRoles"
      @item-selected="handleItemSelected"
      @add-item-selected="addNewRole"
      :parent-name="currentResponsibility?.data?.name || ''"
      :hasMoreData="hasMoreData"
      :isLoadingMore="isLoadingMore"
      @load-more="loadMoreRoles"
      @search="searchRoles"
      :isAssigning="isAssigningObject"
    />
    <BadgeConfirmationDialog
      :isVisible="showBadgeConfirmationDialog"
      :badgeData="badgeData"
      :badgeType="
        badgeData?.payload?.issued_method == 'given' ? 'Give' : 'Award'
      "
      :responsibilityName="currentOrgResponsibility?.data?.name || ''"
      :employee="{
        name: `${evalModalEmpState?.firstName} ${evalModalEmpState?.lastName}`,
        avatar: evalModalEmpState?.photoUrl,
      }"
      :level="getBadgeLevel(badgeData?.payload?.level)"
      @close="showBadgeConfirmationDialog = false"
      :currentEmployee="evalModalEmpState"
      @onClick="onClick"
    />
    <AwardBadgeDialog
      :employee="{
        name: `${evalModalEmpState?.firstName}`,
        avatar: evalModalEmpState?.photoUrl,
      }"
      :level="awardBadgeLevel"
      :isVisible="showAwardBadgeModal"
      @skip="showAwardBadgeModal = false"
      @close="showAwardBadgeModal = false"
      @activate="awardBadge"
      :currentEmployee="evalModalEmpState"
      :responsibilityName="currentOrgResponsibility?.data?.name || ''"
    />
  </div>
</template>
<script>
import AwardBadgeDialog from "@components/AwardBadgeDialog/AwardBadgeDialog.vue";
import AttachedResponsibilityToRole from "@components/RolesCatalog/AttachedResponsibilityToRole.vue";
import ExResponsibilityBadgeHolder from "@components/ResponsibilityBadgeHolder/ExResponsibilityBadgeHolder.vue";
import ExDeleteCheckpoint from "@components/DeleteCheckpointPopup/DeleteCheckpoint.vue";
import GeneratingWithAIDialog from "@components/AI/GeneratingWithAIDialog.vue";
import AICheckpointsDialog from "@components/AI/AICheckpointsDialog.vue";
import ActivateCheckpoint from "@components/RolesCatalog/ActivateCheckpoint.vue";
import RetireCheckpoint from "@components/RolesCatalog/RetireCheckpoint.vue";
import ReActivateCheckpoint from "@components/RolesCatalog/ReActivateCheckpoint.vue";
import EvalResponsibilityModal from "@components/EvalResponsibilityModal/EvalResponsibilityModal.vue";
import {
  updateReActivateResponsibility,
  responsibilityStateUpdate,
  deleteResponsibility,
  updateActivateResponsibility,
  createProficiencyBadge,
  deleteResponsibilityBadge,
  getListofResponsibility,
  moveCheckpointOnResponsibility,
  getPositionId,
  getRole,
  updateRetireResponsibility,
  updateArchiveResponsibility,
  updateUnArchiveResponsibility,
  createBulkCheckpoints,
  askOpenai,
} from "@/api";
import RenameResponsibility from "@components/RolesCatalog/RenameResponsibility.vue";
import DeleteResponsibility from "@components/RolesCatalog/DeleteResponsibility.vue";
import ActivateResponsibility from "@components/RolesCatalog/ActivateResponsibility.vue";
import RetireResponsibility from "@components/RolesCatalog/RetireResponsibility.vue";
import DeActivateResponsibility from "@components/RolesCatalog/DeActivateResponsibility.vue";
import ReActivateResponsibility from "@components/RolesCatalog/ReActivateResponsibility.vue";
import responsibilityMixin from "@components/views/mixins/responsibilityMixin";
import roleMixin from "@components/views/mixins/roleMixin";
import MoveCheckpointDialog from "@components/RolesCatalog/MoveCheckpointDialog/MoveCheckpointDialog.vue";
import BadgeConfirmationDialog from "@components/BadgeConfirmationDialog/BadgeConfirmationDialog.vue";
import ArchivePopUp from "@components/common/ArchivePopUp.vue";
import RemoveBadgeDialog from "@components/RemoveBadgeDialog/RemoveBadgeDialog.vue";
import { mapState } from "vuex";

export default {
  name: "ResBadgeHolderView",
  components: {
    ExResponsibilityBadgeHolder,
    AttachedResponsibilityToRole,
    ExDeleteCheckpoint,
    ActivateCheckpoint,
    RetireCheckpoint,
    ReActivateCheckpoint,
    EvalResponsibilityModal,
    RenameResponsibility,
    DeleteResponsibility,
    ActivateResponsibility,
    RetireResponsibility,
    DeActivateResponsibility,
    ReActivateResponsibility,
    MoveCheckpointDialog,
    BadgeConfirmationDialog,
    ArchivePopUp,
    AwardBadgeDialog,
    GeneratingWithAIDialog,
    AICheckpointsDialog,
    RemoveBadgeDialog,
  },
  mixins: [responsibilityMixin, roleMixin],
  data() {
    return {
      isAssigningBadge: false,
      employeeModalRenderKey: 0,
      showBadgeDialog: false,
      showRemoveBadgeDialog: false,
      selectedBadgeForRemoval: null,
      currentResponse: null,
      modalHeaderState: null,
      dataResponsibilitiesBadge: [],
      badgeEmployeeData: [],
      employeeFilterData: [],
      badgeFrameItems: [],
      menuItems: [
        { title: "Checklist", count: 0 },
        { title: "Badge Holders", count: 0 },
        { title: "Assignments", count: 0 },
        { title: "Defaults", count: null },
      ],
      items: [],
      attachableRoles: [],
      currentPage: 1,
      hasMoreData: false,
      isLoadingMore: false,
      currentResponsibilityId: null,
      badgeData: null,
      updateImportanceData: null,
      resChatter: [],
      showAwardBadgeModal: false,
      awardBadgeLevel: null,
      paramType: null,
      checklistTask: [],
      showDeleteDialog: false,
      checkpointId: null,
      checkpointData: null,
      showActivateCheckpointDialog: false,
      showRetireCheckpointDialog: false,
      showReActivateCheckpointDialog: false,
      showMoveCheckpointDialog: false,
      currentCheckPoint: null,
      totalChatterData: 0,
      activeCheckPoints: 0,
      currentResponsibilityData: null,
      openEvalResponsibility: false,
      badges: [
        {
          badge_id: "Apprentice",
          type: "Given",
        },
        {
          badge_id: "Professional",
          is_force: true,
        },
        {
          badge_id: "Coach",
        },
        {
          badge_id: "Master",
          is_force: false,
        },
      ],
      checkpointsData: [],
      evalModalHeaderState: null,
      evalModalEmpState: null,
      currentOrgResponsibility: null,
      currentResponsibility: null,
      showRenameResponsibilityDialog: false,
      deleteResponsibilityDialog: false,
      showActivateResponsiblityDialog: false,
      showRetireResponsibilityDialog: false,
      showDeActivateResponsiblityDialog: false,
      showReActivateResponsiblityDialog: false,
      showArchihvedResponsiblityDialog: false,
      showAttachRoleDialog: false,
      chatterList: [],
      totalCheckpointChatter: 0,
      assignmentsList: [],
      totalRespAssignments: 0,
      attachmentId: null,
      existingResponsibilitiesNames: [],
      positionHeaderState: {
        status: "",
        icon: "org_icon_position",
        label: "Position",
        name: "",
      },
      rolesHeaderState: {
        status: "",
        icon: "org_icon_role",
        label: "Position",
        name: "",
      },
      showBadgeConfirmationDialog: false,
      archiveAction: null,
      currentObj: "responsibility",
      aiState: {
        dialog: false,
        loading: {
          show: false,
          text: "",
        },
        data: {
          visible: [],
          stored: [],
          remaining: 0,
          storedWithProficiency: [],
        },
      },
      aiCheckpointsDialogKey: 0,
      isAIProcessExecuting: false,
      aiGenerating: false,
      aiRequestPromise: null,
      aiSuccessDataReady: false,
      aiLogSeq: 0,
      showResponsibilityAssignmentTab: false,
      showResponsibilityDefaultTab: false,
      isAssigningObject: false,
    };
  },
  async mounted() {
    this.paramType =
      this.$route.params?.type === "role" ? "role" : "responsibility";
    this.accountId = JSON.parse(localStorage.getItem("currentAccountID"));
    this.$loader.show();
    // Initialize feature flag for responsibility assignment tab
    this.showResponsibilityAssignmentTab = await this.$getFlag(
      "show_responsibilityAssignmentTab",
      false
    );
    this.showResponsibilityDefaultTab = await this.$getFlag(
      "show_responsibilityDefaultTab",
      false
    );

    await this.loadResBadgeHolders(
      this.accountId,
      this.$route.params.objId,
      this.paramType
    );

    if (this.$route.name === "OrgPositionRolesResponse") {
      await this.getPositionByID();
      await this.getRoleByID();
    }
    if (this.$route.name === "ReadinessCatalogsRolesResponse") {
      await this.getRoleByID();
    }
    if (this.$route.name === "ReadinessCatalogsResponsibilityResponse") {
      await this.getRoleByID();
    }
    this.$loader.hide();
  },
  computed: {
    ...mapState("readinessCatalogsStore", {
      storeRoles: (state) => state.roles,
    }),
    showAttachResponsibilitiesPicker() {
      return this.$store.getters["featureFlags/ideaMDP389"];
    },
    computedMenuItems() {
      const accessPermission = JSON.parse(
        localStorage.getItem("accessPermission")
      );
      const items = [...this.menuItems];

      if (
        accessPermission?.has_employee &&
        !accessPermission?.is_owner &&
        !accessPermission?.is_co_owner &&
        !accessPermission?.has_readiness_access
      ) {
        // For employees, keep only Checklist
        return items.filter((item) => item.title === "Checklist");
      }

      // Filter out tabs based on feature flags
      let filteredItems = items;

      if (!this.showResponsibilityAssignmentTab) {
        filteredItems = filteredItems.filter(
          (item) => item.title !== "Assignments"
        );
      }

      if (!this.showResponsibilityDefaultTab) {
        filteredItems = filteredItems.filter(
          (item) => item.title !== "Defaults"
        );
      }

      return filteredItems;
    },
    chatterPage() {
      return Math.ceil(this.chatterList.length / 10);
    },
    computedBreadItems() {
      const accessPermission = JSON.parse(
        localStorage.getItem("accessPermission")
      );
      let items = [];

      if (
        accessPermission?.has_employee &&
        this.$route.name === "AsMasterResponsibilities"
      ) {
        // Show only 2 items for employees
        items = [
          {
            text: "Mastered Responsibilities",
            disabled: false,
            href: "/my-stuff/master",
          },
          {
            text: `${this.currentOrgResponsibility?.data?.name}`,
            disabled: true,
          },
        ];
      } else {
        // Show 3 items for non-employees
        items = [
          {
            text: "Readiness Catalogs",
            disabled: false,
            href: "/readiness/catalogs",
          },
          {
            text: "Responsibilities",
            disabled: false,
            href: "/readiness/catalogs/responsibilities",
          },
          {
            text: "Responsibility",
            disabled: true,
          },
        ];

        if (this.$route.name === "ReadinessCatalogsRolesResponse") {
          items[1] = {
            text: "Roles",
            disabled: false,
            href: "/readiness/catalogs/roles",
          };
          items[2] = {
            text: `${this.rolesHeaderState?.name}`,
            icon: `${this.rolesHeaderState?.icon}`,
            disabled: false,
            href: "/readiness/catalogs/roles",
          };
          items[3] = {
            text: "Responsibility",
            disabled: true,
          };
        }
        if (this.$route.name === "ReadinessCatalogsResponsibilityResponse") {
          items[1] = {
            text: "Roles",
            disabled: false,
            href: "/readiness/catalogs/roles",
          };
          items[2] = {
            text: `${this.rolesHeaderState?.name}`,
            icon: `${this.rolesHeaderState?.icon}`,
            disabled: false,
            href: `/readiness/catalogs/roles/${this.$route.params.roleId}`,
          };
          items[3] = {
            text: "Responsibility",
            disabled: true,
          };
        }
        if (this.$route.params.type === "roles") {
          items[1] = {
            text: "Roles",
            disabled: false,
            href: "/readiness/catalogs/roles",
          };
          items[2] = {
            text: "Role",
            disabled: true,
          };
        }
        if (this.$route.name === "OrgPositionDetailObjId") {
          items[0] = {
            text: "Positions organization",
            disabled: false,
            href: "/organization/positions",
          };
          items[1] = {
            text: "Roles attached",
            disabled: false,
            href: `/organization/positions/position/${this.$route.params.pId}`,
          };
          items[2] = {
            text: "Role",
            disabled: true,
          };
        }
        if (this.$route.name === "OrgPositionRolesResponse") {
          items[0] = {
            text: "Positions organization",
            disabled: false,
            href: "/organization/positions",
          };
          items[1] = {
            text: `${this.positionHeaderState?.name}`,
            icon: `${this.positionHeaderState?.icon}`,
            disabled: false,
            href: `/organization/positions/position/${this.$route.params.pId}`,
          };
          items[2] = {
            text: `${this.rolesHeaderState?.name}`,
            icon: `${this.rolesHeaderState?.icon}`,
            disabled: false,
            href: `/organization/positions/${this.$route.params.pId}/roles/${this.$route.params.roleId}`,
          };
          items[3] = {
            text: "Responsibility",
            disabled: true,
          };
        }
      }
      return items;
    },
    sanitizedRoles() {
      if (this.storeRoles && this.storeRoles.length > 0) {
        const attachedResponsibilityIds = new Set(
          this.currentResponsibility?.data?.attachments.map(
            (attachment) => attachment.id
          )
        );
        const unmatchedResponsibilities = this.storeRoles
          .filter((item) => !attachedResponsibilityIds.has(item.id))
          .filter((item) => item.status !== "retired");
        return unmatchedResponsibilities.map((item) => ({
          id: item.id,
          code: item.code_str.match(/\d+/)[0],
          name: item.name,
          status: item.status,
        }));
      } else {
        return [];
      }
    },
  },
  methods: {
    resetAIData() {
      this.aiState.data = {
        visible: [],
        stored: [],
        remaining: 0,
      };
      this.aiState.dialog = false;
      this.aiCheckpointsDialogKey++;
    },
    async handleFiltersChanged(filterData) {
      // Call the responsibilityMixin method with filter parameters
      const data = { id: this.$route.params.objId };
      const apiParams = {
        ordering: "proficiency_level",
      };

      // Add status filter parameters if provided - convert array to comma-separated string
      if (filterData.filters && filterData.filters.length > 0) {
        apiParams.status = filterData.filters.join(",");
      }

      // Add proficiency level filter parameters if provided - convert to lowercase and comma-separated
      if (filterData.levelFilters && filterData.levelFilters.length > 0) {
        apiParams.proficiency_level = filterData.levelFilters
          .map((level) => level.toLowerCase())
          .join(",");
      }

      // Add search parameter if provided
      if (filterData.search) {
        apiParams.search = filterData.search;
      }

      await this.getResponsiblityChecklist(data, apiParams);
    },
    async onSaveAIData(aiData) {
      this.aiState.dialog = false;
      this.aiCheckpointsDialogKey++;
      try {
        this.isAIProcessExecuting = true;
        const selectedWithProficiency =
          this.aiState.data.storedWithProficiency.filter((el) =>
            aiData.includes(el.checkpoint)
          );
        let bulkCheckpointsData = [];
        selectedWithProficiency.forEach((el) => {
          const obj = {
            level: el.proficiency == "professional" ? 2 : 1,
            criteria: el.checkpoint,
            prefix: "can",
          };
          bulkCheckpointsData.push(obj);
        });

        await createBulkCheckpoints(
          this.accountId,
          this.$route.params.objId,
          bulkCheckpointsData
        );
        await this.loadResBadgeHolders(
          this.accountId,
          this.$route.params.objId,
          this.paramType
        );
        await this.resetAIData();
        await this.loadNewDataSource();
      } catch (e) {
        console.error(e);
      } finally {
        this.isAIProcessExecuting = false;
      }
    },
    showThreeMoreAIData() {
      const storedDataLength = this.aiState.data.stored.length;
      let elCounter = 0;
      this.aiState.data.visible.forEach((el) => {
        elCounter += el.checklist.length;
      });
      const visibleDataLength = elCounter;

      if (this.aiState.data.remaining == 0) {
        this.aiState.data.remaining = storedDataLength;
      }
      let subArray = [];
      if (this.aiState.data.remaining > 3) {
        const newItems = this.aiState.data.stored.slice(
          visibleDataLength,
          visibleDataLength + 3
        );
        subArray.push({
          checklist: [...newItems],
        });
      } else {
        const newItems = this.aiState.data.stored.slice(
          visibleDataLength,
          visibleDataLength + this.aiState.data.remaining
        );
        subArray.push({
          checklist: [...newItems],
        });
      }

      this.aiState.data.visible = [...this.aiState.data.visible, ...subArray];
      this.aiState.data.remaining = storedDataLength - (visibleDataLength + 3);
    },
    async getAICheckpoints(withExclude = false) {
      // If already in progress, re-open the loader (no new request) and exit BEFORE try/finally
      if (this.aiGenerating) {
        if (!this.aiState.loading.show) {
          this.aiState.loading.show = true;
        } else {
          // Force re-render if needed
          this.aiState.loading.show = false;
          this.$nextTick(() => {
            this.aiState.loading.show = true;
          });
        }
        return;
      }

      try {
        this.aiGenerating = true;
        this.aiSuccessDataReady = false;
        this.aiState.loading.text = "Analyzing and creating Checkpoints...";
        this.aiState.loading.show = true;
        const responsibilityName = this.currentOrgResponsibility?.data?.name;

        const prompt = `Suggest a simple list of checkpoints that should be inspected to demonstrate that an employee can
                 ${responsibilityName} but prioritize them by proficiency level where there are only two levels with
                  apprentice the lowest and professional the highest, return only an array in JSON format example:
                [{ proficiency: '', checkpoint: "..." }, { proficiency: '', checkpoint: "..." }] Do not wrap the json codes in JSON markers`;

        const promptWithExclude = `Suggest a simple list of checkpoints that should be inspected to demonstrate that an employee can
                 ${responsibilityName} but prioritize them by proficiency level where there are only two levels with
                  apprentice the lowest and professional the highest, exclude the following items in your response: ${this.checklistTask.map(
                    (el) => el.criteria
                  )}, return only an array in JSON format example:
                 [{ proficiency: '', checkpoint: "..." }, { proficiency: '', checkpoint: "..." }] Do not wrap the json codes in JSON markers`;
        const request = askOpenai({
          model: "gpt-4o-mini",
          instructions: withExclude ? promptWithExclude : prompt,
          input: "string",
        });
        this.aiRequestPromise = request;
        const response = await request;
        this.aiState.data.storedWithProficiency = JSON.parse(
          response.data.response
        );
        this.aiState.data.stored = this.aiState.data.storedWithProficiency.map(
          (el) => el.checkpoint
        );
        this.showThreeMoreAIData();
        this.aiSuccessDataReady = true;
      } catch (e) {
        console.error("[AI] request:error", e);
      } finally {
        this.aiGenerating = false;
        this.aiRequestPromise = null;
        // Close loader when request finishes
        this.aiState.loading.show = false;
        // Always show results if we have valid data, regardless of loader state
        if (this.aiSuccessDataReady) {
          this.aiState.dialog = true;
        }
      }
    },
    async attachResponsibilityToRole() {
      this.isAssigningObject = true;
      this.$loader.setAppLoading(true);
      try {
        await this.attachedResponsibilityToRole();
        this.$notifications.success("Role attached successfully.");
        this.showAttachRoleDialog = false;
      } catch (e) {
        console.log("e: ", e);
      }
      this.isAssigningObject = false;
      this.$loader.setAppLoading(false);
    },
    async addNewRole(item) {
      try {
        this.$loader.show();
        const payload = {
          name: item.name,
          account: this.accountId,
        };
        const newRole = await this.$store.dispatch(
          "readinessCatalogsStore/createRole",
          { role: payload, accountId: this.accountId }
        );
        this.attachmentId = newRole.id;
        await this.attachedResponsibilityToRole();
        this.showAttachRoleDialog = false;
      } catch (e) {
        console.error(e);
      } finally {
        this.$loader.hide();
      }
    },
    async getPositionByID() {
      this.accountId = JSON.parse(localStorage.getItem("currentAccountID"));
      if (!this.$route.params.pId) this.$router.go(0);
      const { data } = await getPositionId(
        this.accountId,
        this.$route.params.pId
      );
      if (data) {
        this.positionHeaderState = {
          status: data.status,
          icon: "org_icon_position",
          label: "Position",
          name: `${this.getOrgCodeName(data)} ${data.name}`,
        };
      }
    },
    async getRoleByID() {
      this.accountId = JSON.parse(localStorage.getItem("currentAccountID"));
      const { data } = await getRole(this.accountId, this.$route.params.roleId);
      if (data) {
        this.rolesHeaderState = {
          status: data.status,
          icon: "org_icon_role",
          label: "Position",
          name: `${this.getOrgCodeName(data)} ${data.name}`,
        };
      }
    },
    getOrgCodeName(currentRole) {
      if (currentRole?.code_str) {
        return currentRole.code_str.split(" ")[0];
      } else {
        return "#" + currentRole?.code;
      }
    },
    async getResponsibility() {
      const data = await getListofResponsibility(this.accountId);
      if (data && data.data && data.data.results) {
        const realIdToExclude = this.currentOrgResponsibility.realId;
        const unmatchedResponsibilities = data.data.results.filter(
          (item) => item.status !== "retired" && item.id !== realIdToExclude
        );
        this.items = unmatchedResponsibilities.map((item) => ({
          id: item.id,
          code: item.code_str.match(/\d+/)[0],
          name: item.name,
          status: item.status,
        }));
      }
    },
    handleItemSelected(data) {
      if (data && Object.prototype.hasOwnProperty.call(data, "id")) {
        this.attachmentId = data.id;
      }
    },
    async addHandleItemSelected(item) {
      try {
        this.$loader.show();
        const payload = {
          name: item.name,
          accountId: this.accountId,
        };
        const newResponsibility = await this.$store.dispatch(
          "readinessCatalogsStore/createResponsibility",
          payload
        );
        this.attachmentId = newResponsibility.data.id;
        this.showMoveCheckpointDialog = false;
      } catch (e) {
        console.error(e);
      } finally {
        this.$loader.hide();
      }
    },
    async moveCheckpoint() {
      try {
        this.$loader.setAppLoading(true);
        const checkId = this.currentCheckPoint?.id;
        const payload = {
          responsibility_id: this.attachmentId,
        };
        const { data } = await moveCheckpointOnResponsibility(
          this.accountId,
          checkId,
          payload
        );
        this.$loader.setAppLoading(false);
        this.$router.push(
          `/readiness/catalogs/responsibilities/${this.attachmentId}?tab=checklist&move=${data.criteria}`
        );
        this.showMoveCheckpointDialog = false;
        await this.loadResBadgeHolders(
          this.accountId,
          this.$route.params.objId,
          this.paramType
        );
      } catch (e) {
        this.$loader.setAppLoading(false);
        console.log("e: ", e);
      }
    },
    async weightChanged(data) {
      this.updateImportanceData = {
        assignment_id: data.assignment_id,
        new_importance: data.weight,
        assignment_type: "responsibility_assignment",
      };
      await this.updateImportanceValue();
    },
    async removeBadgeByResponsibilityId(badgeData) {
      try {
        if (badgeData?.id) {
          this.$loader.setAppLoading(true);
          await deleteResponsibilityBadge(this.accountId, badgeData?.id, {
            badge: badgeData?.id,
            method: "string",
            reason: "string",
          });
          this.openEvalResponsibility = false;
          await this.fetchResponsibilityDetails();
          this.$loader.show();
          // Use the mixin method that properly populates badgeFrameItems
          await this.getResponsiblityBadges(
            this.currentResponsibilityData,
            this.paramType
          );
          this.updateEmployeeList(badgeData?.resId);
          this.evalModalEmpState = {
            ...this.evalModalEmpState,
            badgeList: this.badgeFrameItems,
          };
          this.$loader.setAppLoading(false);
          this.$loader.hide();
        }
      } catch (e) {
        console.error("error: ", e);
      } finally {
        this.$loader.setAppLoading(false);
      }
    },
    showAwardBadge(obj) {
      this.openEvalResponsibility = false;
      this.showAwardBadgeModal = true;
      this.awardBadgeLevel = obj?.level;
    },
    async awardBadge(isNotify = false) {
      this.showAwardBadgeModal = false;
      this.$loader.show();
      try {
        const routeParams = this.$route?.params;
        let responsibilityId = null;
        if (routeParams && routeParams?.objId) {
          responsibilityId = routeParams?.objId;
        } else if (this.currentSelectRes?.id) {
          responsibilityId = this.currentSelectRes?.id;
        }
        if (!responsibilityId) throw "no responsibility id available";
        const account = JSON.parse(localStorage.getItem("currentAccountID"));
        const data = {
          employee: this.evalModalEmpState.id,
          responsibility: responsibilityId,
          level: this.getBadgeLevelByLabel(this.awardBadgeLevel),
          given: false,
          issued_method: "awarded",
          notify: isNotify,
        };
        await createProficiencyBadge(account, data);
        this.showAwardBadgeModal = false;
        await this.fetchResponsibilityDetails();
        // Use the mixin method that properly populates badgeFrameItems
        await this.getResponsiblityBadges(
          this.currentResponsibilityData,
          this.paramType
        );
        this.updateEmployeeList(responsibilityId);
        this.evalModalEmpState = {
          ...this.evalModalEmpState,
          badgeList: this.badgeFrameItems,
        };
        this.$loader.hide();
      } catch (e) {
        console.log("error: ", e);
      } finally {
        this.$loader.hide();
      }
    },

    getBadgeLevelByLabel(level) {
      if (!level || typeof level !== "string") {
        return 0; // Default to novice if level is null, undefined, or not a string
      }
      switch (level.toLowerCase()) {
        case "novice":
          return 0;
        case "apprentice":
          return 1;
        case "professional":
          return 2;
        case "coach":
          return 3;
        case "master":
          return 4;
        default:
          return 0;
      }
    },
    async upgradeBadge(upgradeData) {
      try {
        this.badgeData = { payload: upgradeData?.payload?.newBadge };
        await this.onClick(false);
      } catch (e) {
        console.log(e);
      }
    },
    async grantOrForceBadge(badgeData) {
      this.openEvalResponsibility = false;
      this.showBadgeConfirmationDialog = true;
      this.badgeData = badgeData;
    },
    async onClick(isNotify = false) {
      this.showBadgeConfirmationDialog = false;
      this.openEvalResponsibility = false;
      this.$loader.show();
      try {
        if (this.badgeData?.currentBadge) {
          await deleteResponsibilityBadge(
            this.accountId,
            this.badgeData?.currentBadge,
            {
              badge: this.badgeData?.currentBadge,
              method: "string",
              reason: "string",
            }
          );
        }
        await createProficiencyBadge(this.accountId, {
          ...this.badgeData.payload,
          notify: isNotify,
        });
        await this.fetchResponsibilityDetails();
        await this.getResponsiblityBadges(
          this.currentResponsibilityData,
          this.paramType
        );
        this.updateEmployeeList(this.badgeData.payload.responsibility);
        this.$loader.hide();
      } catch (e) {
        console.error(e);
      } finally {
        this.$loader.setAppLoading(false);
      }
    },
    updateResponsibilityBadges(list) {
      this.dataResponsibilitiesBadge = list;
      const userMap = this.employeeFilterData.reduce((map, user) => {
        map[user.id] = user;
        return map;
      }, {});
      this.badgeFrameItems = this.dataResponsibilitiesBadge
        .map((badge) => {
          const user = userMap[badge.issued_to];
          if (user) {
            let statusName = "";
            if (badge.status === "good_standing") {
              statusName = "Good Standing";
            } else if (badge.status === "forced" || badge.status == "given") {
              statusName = "Given";
            } else {
              statusName = "Obsolete";
            }
            return {
              id: badge.id,
              proficiencylevel: badge.level,
              avatar: user.avatar,
              firstName: user.firstName,
              lastName: user.lastName,
              dot: statusName,
              empId: user.id,
              is_current: badge.is_current,
              expires_when_obsolete: badge.expires_when_obsolete,
              removed_by: badge.removed_by,
            };
          }
        })
        .filter((item) => item !== undefined);
    },
    async updateEmployeeList() {
      // Badge employees logic has been removed - using employee store directly
      // If needed, the modal can fetch employees independently
      this.badgeEmployeeData = [];
      this.employeeModalRenderKey++;
    },
    async updateEvaluationCheckPointData() {
      await this.loadListActiveCheckpointsEvalV2({
        employee: this.evalModalEmpState,
      });
    },
    openForceBadgeModal() {
      this.showBadgeDialog = true;
      this.activeCheckPoints =
        (this.currentResponsibilityData.active_apprentice_checkpoints || 0) +
        (this.currentResponsibilityData.active_coach_checkpoints || 0) +
        (this.currentResponsibilityData.active_master_checkpoints || 0) +
        (this.currentResponsibilityData.active_professional_checkpoints || 0);
    },
    backForceBadge() {
      this.showBadgeDialog = false;
    },
    removeBadge(badge) {
      if (!badge || !badge.id) {
        console.error("Invalid badge data:", badge);
        this.$toast?.error("Invalid badge data");
        return;
      }

      // Extract badge level and name
      const badgeLevel = badge.proficiencylevel || badge.level || "";
      const badgeLevelName = this.getBadgeLevelName(badgeLevel);

      // Get employee name
      const employeeName =
        badge.firstName && badge.lastName
          ? `${badge.firstName} ${badge.lastName}`.trim()
          : badge.employeeName || "";

      this.selectedBadgeForRemoval = {
        id: badge.id,
        badgeName: badgeLevelName,
        level: badgeLevel,
        employeeName: employeeName,
      };

      // Store badgeData for mixin compatibility
      this.badgeData = badge;

      this.showRemoveBadgeDialog = true;
    },
    getBadgeLevelName(level) {
      if (typeof level === "string") {
        // Capitalize first letter
        return level.charAt(0).toUpperCase() + level.slice(1).toLowerCase();
      }
      const levelMap = {
        1: "Apprentice",
        2: "Professional",
        3: "Coach",
        4: "Master",
      };
      return levelMap[level] || "Apprentice";
    },
    async handleConfirmRemoveBadge({ reason: removeReason }) {
      if (
        !this.selectedBadgeForRemoval ||
        !this.selectedBadgeForRemoval.id ||
        !removeReason?.trim()
      ) {
        this.$toast?.error("Please provide a reason for removing the badge");
        return;
      }

      try {
        this.$loader.setAppLoading(true);
        const payload = {
          badge: this.selectedBadgeForRemoval.id,
          method: "removed",
          reason: removeReason.trim(),
        };

        await deleteResponsibilityBadge(
          this.accountId,
          this.selectedBadgeForRemoval.id,
          payload
        );

        await this.getResponsiblityBadges(this.currentResponse, this.paramType);
        await this.getRespAssignments();
        await this.fetchResponsibilityDetails();
        await this.updateEmployeeList(this.currentResponse?.id);

        this.$toast?.success("Badge removed successfully");

        this.showRemoveBadgeDialog = false;
        this.selectedBadgeForRemoval = null;
        this.badgeData = null;
      } catch (error) {
        console.error("Error removing badge:", error);
        this.$toast?.error("Error removing badge");
      } finally {
        this.$loader.setAppLoading(false);
      }
    },
    handleCloseRemoveBadgeDialog() {
      this.showRemoveBadgeDialog = false;
      this.selectedBadgeForRemoval = null;
      this.badgeData = null;
    },
    cancelAddition() {
      // Keep for backward compatibility but use handleCloseRemoveBadgeDialog
      this.handleCloseRemoveBadgeDialog();
    },
    getWeight() {
      if (
        this.currentResponse?.proficiency_weight > 0 &&
        this.currentResponse?.knowledge_weight === 0
      ) {
        return this.currentResponse?.proficiency_weight;
      } else if (
        this.currentResponse?.proficiency_weight === 0 &&
        this.currentResponse?.knowledge_weight > 0
      ) {
        return this.currentResponse?.knowledge_weight;
      }
      return 0;
    },
    checkDropdownOption(data) {
      this.checkpointData = data.data;
      if (data.item.name === "Delete") {
        this.showDeleteDialog = data.showDialog;
      } else if (data.item.name === "Activate") {
        this.showActivateDialog = data.showDialog;
      }
      this.checkpointId = data.data.id;
    },
    optionClick(operation) {
      this.currentCheckPoint = JSON.parse(JSON.stringify(operation.data));
      switch (operation.item.value) {
        case "activate_checkpoint":
          this.showActivateCheckpointDialog = true;
          break;
        case "retire_checkpoint":
          this.showRetireCheckpointDialog = true;
          break;
        case "reactivate_checkpoint":
          this.showReActivateCheckpointDialog = true;
          break;
        case "move_checkpoint":
          this.showMoveCheckpointDialog = true;
          this.getResponsibility();
          break;
        default:
          break;
      }
    },
    handleReadinessOperations(operation) {
      switch (operation.item.value) {
        case "rename_responsibility":
          this.showRenameResponsibilityDialog = true;
          break;
        case "delete_responsibility":
          this.deleteResponsibilityDialog = true;
          break;
        case "activate_responsibility":
          this.showActivateResponsiblityDialog = true;
          break;
        case "retire_responsibility":
          this.showRetireResponsibilityDialog = true;
          break;
        case "de_activate_responsibility":
          this.showDeActivateResponsiblityDialog = true;
          break;
        case "re_activate_responsibility":
          this.showReActivateResponsiblityDialog = true;
          break;
        case "archive_action":
          this.archiveAction = "archive";
          this.showArchihvedResponsiblityDialog = true;
          break;
        case "unarchive_action":
          this.archiveAction = "unarchive";
          this.showArchihvedResponsiblityDialog = true;
          break;
        case "attach_role":
          this.currentResponsibility = this.currentOrgResponsibility;
          this.currentResponsibilityId = this.currentResponsibility.realId;
          this.getListOfRoles(this.currentResponsibilityId);
          this.showAttachRoleDialog = true;
          break;
        default:
          break;
      }
    },
    closeDialog() {
      this.showRenameResponsibilityDialog = false;
      this.deleteResponsibilityDialog = false;
      this.showActivateResponsiblityDialog = false;
      this.showRetireResponsibilityDialog = false;
      this.showDeActivateResponsiblityDialog = false;
      this.showReActivateResponsiblityDialog = false;
      this.showArchihvedResponsiblityDialog = false;
      this.archiveAction = null;
      this.showAttachRoleDialog = false;
    },
    async renameOrgResponsibility(newName) {
      try {
        this.$loader.setAppLoading(true);
        const id = this.currentOrgResponsibility?.realId;
        if (id) {
          const payload = {
            name: newName,
            account: this.accountId,
          };
          await responsibilityStateUpdate(this.accountId, id, payload);
          this.currentOrgResponsibility = null;
          this.closeDialog();
          this.$loader.setAppLoading(false);
          await this.loadResBadgeHolders(
            this.accountId,
            this.$route.params.objId,
            this.paramType
          );
        }
      } catch (e) {
        this.$loader.setAppLoading(false);
        console.error("error: ", e);
      }
    },
    async activateOrgResponsibility() {
      try {
        this.$loader.setAppLoading(true);
        const id = this.currentOrgResponsibility?.realId;
        const name = this.currentOrgResponsibility?.data?.name;
        if (!id || !name) {
          throw "data missing error";
        }
        await updateActivateResponsibility(this.accountId, id);
        this.closeDialog();
        this.$loader.setAppLoading(false);
        await this.loadResBadgeHolders(
          this.accountId,
          this.$route.params.objId,
          this.paramType
        );
      } catch (e) {
        this.$loader.setAppLoading(false);
        console.error("error: ", e);
      }
    },
    async retireOrgResponsibility() {
      try {
        this.$loader.setAppLoading(true);
        const id = this.currentOrgResponsibility?.realId;
        const name = this.currentOrgResponsibility?.data?.name;
        if (!id || !name) {
          throw "data missing error";
        }
        const payload = {
          status: "retired",
          name: this.currentOrgResponsibility?.data?.name,
          account: this.accountId,
        };
        await updateRetireResponsibility(this.accountId, id, payload);
        this.closeDialog();
        this.$loader.setAppLoading(false);
        await this.loadResBadgeHolders(
          this.accountId,
          this.$route.params.objId,
          this.paramType
        );
      } catch (e) {
        this.$loader.setAppLoading(false);
        console.log("error: ", e);
      }
    },
    async deleteOrgResponsibility() {
      try {
        this.$loader.setAppLoading(true);
        const idRole = this.currentOrgResponsibility.realId;
        await deleteResponsibility(this.accountId, idRole);
        this.closeDialog();
        this.$loader.setAppLoading(false);
        this.currentOrgResponsibility = null;
        this.$router.push("/readiness/catalogs/responsibilities");
      } catch (e) {
        this.$loader.setAppLoading(false);
        console.error("e: ", e);
      }
    },
    async deActivateOrgResponsibility() {
      try {
        this.$loader.setAppLoading(true);
        const id = this.currentOrgResponsibility?.realId;
        const name = this.currentOrgResponsibility?.data?.name;
        if (!id || !name) {
          throw "data missing error";
        }
        const payload = {
          status: "inactive",
          name: this.currentOrgResponsibility?.data?.name,
          account: this.accountId,
        };
        await responsibilityStateUpdate(this.accountId, id, payload);
        this.closeDialog();
        this.$loader.setAppLoading(false);
        await this.loadResBadgeHolders(
          this.accountId,
          this.$route.params.objId,
          this.paramType
        );
      } catch (e) {
        console.error("error: ", e);
        this.$loader.setAppLoading(false);
      }
    },
    async reActivateOrgResponsibility() {
      try {
        this.$loader.setAppLoading(true);
        const id = this.currentOrgResponsibility?.realId;
        const name = this.currentOrgResponsibility?.data?.name;
        if (!id || !name) {
          throw "data missing error";
        }
        const payload = {
          status: "active",
          name: this.currentOrgResponsibility?.data?.name,
          account: this.accountId,
        };
        await updateReActivateResponsibility(this.accountId, id, payload);
        this.closeDialog();
        this.$loader.setAppLoading(false);
        await this.loadResBadgeHolders(
          this.accountId,
          this.$route.params.objId,
          this.paramType
        );
      } catch (e) {
        this.$loader.setAppLoading(false);
        console.error("error: ", e);
      }
    },
    async reloadBadgeHolderItems() {
      this.$loader.show();
      await this.loadResBadgeHolders(
        this.accountId,
        this.$route.params.objId,
        this.paramType
      );
      this.$loader.hide();
    },
    getBadgeLevel(level) {
      switch (level) {
        case 1:
          return "Apprentice";
        case 2:
          return "Professional";
        case 3:
          return "Coach";
        case 4:
          return "Master";
        default:
          return "Unknown";
      }
    },
    async onArchiveCatalogs() {
      this.$loader.setAppLoading(true);
      if (this.archiveAction === "archive") {
        const id = this.currentOrgResponsibility?.realId;
        const objTpye = "responsibility";
        await updateArchiveResponsibility(this.accountId, objTpye, id);
        this.showArchihvedResponsiblityDialog = false;
        this.currentOrgResponsibility = null;
        await this.loadResBadgeHolders(
          this.accountId,
          this.$route.params.objId,
          this.paramType
        );
      } else if (this.archiveAction === "unarchive") {
        const id = this.currentOrgResponsibility?.realId;
        const objTpye = "responsibility";
        await updateUnArchiveResponsibility(this.accountId, objTpye, id);
        this.showArchihvedResponsiblityDialog = false;
        this.currentOrgResponsibility = null;
        await this.loadResBadgeHolders(
          this.accountId,
          this.$route.params.objId,
          this.paramType
        );
      }
      this.$loader.setAppLoading(false);
    },
  },
  watch: {
    totalChatterData(newVal) {
      if (newVal) {
        const index = this.menuItems.findIndex((el) => el.title == "Chatter");
        if (index !== -1) {
          this.menuItems[index].count = newVal;
        }
      }
    },
    totalRespAssignments(newVal) {
      if (newVal) {
        const index = this.menuItems.findIndex(
          (el) => el.title == "Assignments"
        );
        if (index !== -1) {
          this.menuItems[index].count = newVal;
        }
      }
    },
  },
};
</script>
<style scoped>
.badge-container {
  width: 100%;
  padding: 25px;
}
</style>
